import { Box, Stack, Typography } from "@mui/material";
import { red } from "@mui/material/colors";
import { Warning } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export default function ErrorComponent() {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        height: "40vh",
        alignItems: "center",
      }}
    >
      <Stack justifyContent="center" alignItems="center" spacing={1}>
        <Warning sx={{ fontSize: 60, color: red[500] }} />
        <Stack>
          <Typography variant="h4" textAlign="center">
            {t("Something went wrong.")}
          </Typography>
          <Typography textAlign="center">
            {t("Unable to get intended data.") + " " + t("Retry.")}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
